import styled from '@emotion/styled';
import { tokens, Stack } from '@hotjar/hotsauce';
import { SiteIcon } from '@hotjar/webapp/features/Activation/SiteIcon';

const Wrapper = styled(Stack)`
  margin-bottom: ${tokens.spacer.x2};
`;

const Url = styled.span`
  ${tokens.truncateText()};
  ${tokens.text('body2')};
`;

export const SiteUrl = ({ url }: { url: string }): JSX.Element => {
  return (
    <Wrapper spacing="x1">
      <SiteIcon siteUrl={url} />
      <Url title={url}>{url}</Url>
    </Wrapper>
  );
};
